import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../shared/shared.module';
import { MobileFooterComponent } from './mobile-footer.component';
import { MaterialModule } from 'src/app/shared/material.module';
import { MatBadgeModule } from '@angular/material/badge';


@NgModule({
  declarations: [MobileFooterComponent],
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule,
    MatBadgeModule
  ],
  exports: [
    MobileFooterComponent
  ]
})
export class MobileFooterModule { }
